/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var CreateInternetExamDto;
(function (CreateInternetExamDto) {
    let modality;
    (function (modality) {
        modality["CR"] = "CR";
        modality["CT"] = "CT";
        modality["DR"] = "DR";
        modality["DX"] = "DX";
        modality["RF"] = "RF";
        modality["RG"] = "RG";
        modality["MG"] = "MG";
        modality["MR"] = "MR";
        modality["OT"] = "OT";
        modality["PT"] = "PT";
        modality["SC"] = "SC";
        modality["US"] = "US";
        modality["CT_SR"] = "CTSR";
    })(modality = CreateInternetExamDto.modality || (CreateInternetExamDto.modality = {}));
    let priority;
    (function (priority) {
        priority["URGENT"] = "URGENT";
        priority["IMPORTANT"] = "IMPORTANT";
        priority["NORMAL"] = "NORMAL";
    })(priority = CreateInternetExamDto.priority || (CreateInternetExamDto.priority = {}));
})(CreateInternetExamDto || (CreateInternetExamDto = {}));
